export * from './keySharing'

export const getAgentSignatureMessage = () =>
  `${window.location.host} wants you to sign this message to generate a Portal-specific signing agent for your portal`
